import React, { useState } from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { useNavigate } from "react-router-dom";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Container } from "@mui/material";
import logo from "./../../assets/safe_logo.png";
import RoundButton from "../../components/RoundButton";
import { useDispatch, useSelector } from "react-redux";
import {
  checkUserExistsbyemail,
  phoneValidationRequest,
} from "../../redux/signup/action";
import { updateSignUpFrom } from "../../redux/signup/constants";
import { useForm, Controller, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import createAccountScheme from "../../validations/createAccountScheme";
import codeMessage from "../../services/apiManager/httpMessages";
import CustomLoader from "../../components/CustomLoader";
import { enqueueSnackbar } from "notistack";
import background_image from "./../../assets/png/background_image.png";
import { useResponsive } from "../../hooks/useResponsive";
import LableComponent from "../../components/LableComponent";
import { PasswordChecklist } from "../signup";
import { useTranslation } from "react-i18next";

const OperatorSignup = () => {
  const { isLoading, createAccount } = useSelector(
    (state) => state.signUpReducer,
  );
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const smDown = useResponsive("down", "sm");

  const {
    handleSubmit,
    control,
    setError,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: createAccount,
    resolver: yupResolver(createAccountScheme),
  });

  const password = useWatch({ control, name: "password" });

  const submitForm = (values) => {
    dispatch(
      checkUserExistsbyemail({ email: values?.userEmail }, (response) => {
        if (response?.statusCode === 202) {
          enqueueSnackbar(response?.message, {
            variant: "error",
          });
        } else {
          if (values?.phoneNumber?.length > 8)
            dispatch(
              phoneValidationRequest(
                values?.phoneNumber,
                values?.countryCode,
                {},
                (response) => {
                  if (response?.message === codeMessage[400]) {
                    setError("phoneNumber", {
                      type: "manual",
                      message: "Invalid phone number",
                    });
                  } else {
                    dispatch(updateSignUpFrom(values));
                    navigate("/companyDetailsPage");
                  }
                },
              ),
            );
        }
      }),
    );
  };

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);

  return (
    <Container
      disableGutters
      maxWidth={false}
      style={{
        position: "relative",
        minHeight: "100vh",
        backgroundColor: "#80BCFF4F",
        backgroundImage: `url(${background_image})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        width: "100vw",
        height: "100%",
      }}
    >
      <Box
        maxWidth="xs"
        sx={{
          flexGrow: 1,
          minHeight: 1,
          width: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            width: 1,
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            flexDirection: ["column", "column", "row"],
          }}
        >
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{ height: 1, width: 1, padding: 0, gap: 5 }}
          >
            <img src={logo} alt="Your Alt Text" />
            <Card
              sx={{
                p: 3,
                width: 1,
                height: 1,
                maxWidth: 600,
                maxHeight: smDown ? "auto" : 550,
                overflow: "auto",
              }}
            >
              <form onSubmit={handleSubmit((data) => submitForm(data))}>
                <Stack spacing={2}>
                  <Typography variant="titleText" color="primary.main">
                    {t("pages.signup.pageHeading")}
                  </Typography>
                  <Controller
                    name="userEmail"
                    disabled={true}
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        label={t("pages.signup.text01")}
                        name="email"
                        type="email"
                        error={!!errors.userEmail}
                        helperText={errors.userEmail?.message}
                      />
                    )}
                  ></Controller>
                  <Stack spacing={1} direction={smDown ? "column" : "row"}>
                    <Controller
                      name="firstName"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          placeholder={t("commonLabels.text07")}
                          label={
                            <LableComponent
                              customLable={t("commonLabels.text07")}
                            />
                          }
                          name="firstName"
                          type="text"
                          error={!!errors.firstName}
                          helperText={errors.firstName?.message}
                        />
                      )}
                    ></Controller>
                    <Controller
                      name="middleName"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          placeholder={t("commonLabels.text15")}
                          label={
                            <LableComponent
                              customLable={t("commonLabels.text15")}
                            />
                          }
                          name="middleName"
                          type="text"
                        />
                      )}
                    ></Controller>
                    <Controller
                      name="lastName"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          placeholder={t("commonLabels.text08")}
                          label={
                            <LableComponent
                              customLable={t("commonLabels.text08")}
                            />
                          }
                          name="lastName"
                          type="text"
                          error={!!errors.lastName}
                          helperText={errors.lastName?.message}
                        />
                      )}
                    ></Controller>
                  </Stack>
                  <Controller
                    name="phoneNumber"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        name="phoneNumber"
                        type="tel"
                        label={
                          <LableComponent
                            customLable={t("commonLabels.text25")}
                          />
                        }
                        placeholder={t("commonLabels.text25")}
                        error={!!errors.phoneNumber}
                        helperText={errors.phoneNumber?.message}
                      />
                    )}
                  ></Controller>
                  <Controller
                    name="password"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        name="password"
                        label={
                          <LableComponent
                            customLable={t("pages.signup.text02")}
                          />
                        }
                        error={!!errors.password}
                        helperText={errors.password?.message}
                        type={showPassword ? "text" : "password"}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  ></Controller>
                  <PasswordChecklist password={password} />
                </Stack>
                <RoundButton
                  sx={{ mt: 5, mb: 2 }}
                  size="large"
                  fullWidth
                  variant="contained"
                  type="submit"
                  color="primary"
                  rounded
                >
                  <Typography variant="buttonText" color="common.buttonText">
                    {t("commonLabels.text17")}
                  </Typography>
                </RoundButton>
              </form>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="center"
              >
                <Typography
                  sx={{ textDecoration: "underline" }}
                  color="primary.main"
                  variant="smallLinkText"
                  underline="hover"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  {t("pages.signup.text07")}
                </Typography>
              </Stack>
            </Card>
          </Stack>
        </Box>
      </Box>
      {isLoading && <CustomLoader />}
    </Container>
  );
};

export default OperatorSignup;
